function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".development_svg__c,.development_svg__e{fill:#fff}.development_svg__c,.development_svg__d{stroke:#1d1f2c}.development_svg__c,.development_svg__d,.development_svg__e,.development_svg__f{stroke-width:2px}.development_svg__d,.development_svg__f,.development_svg__h{fill:none}.development_svg__d,.development_svg__f{stroke-linecap:round}.development_svg__e,.development_svg__f{stroke:#d32f2f}.development_svg__g{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.739 68.596a22.994 22.994 0 010-32.525L36.313 8.497A23 23 0 1168.84 41.022L41.264 68.596a22.994 22.994 0 01-32.525 0z",
  fill: "#ffd5d5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "development_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  className: "development_svg__g",
  d: "M33 50h10v16H33z"
}), /*#__PURE__*/React.createElement("path", {
  className: "development_svg__h",
  d: "M34 51h8v14h-8z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "development_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  className: "development_svg__g",
  d: "M30 64h16a6 6 0 016 6 1 1 0 01-1 1H25a1 1 0 01-1-1 6 6 0 016-6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "development_svg__h",
  d: "M30 65h16a5 5 0 015 5H25a5 5 0 015-5z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "development_svg__c",
  transform: "translate(8 11)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "development_svg__g",
  width: 60,
  height: 46,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  className: "development_svg__h",
  x: 1,
  y: 1,
  width: 58,
  height: 44,
  rx: 5
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "development_svg__d",
  d: "M9.466 46.758h48.241M9.466 19.758h56.632M14 15.758h.05M18 15.758h.05M22 15.758h.05"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "development_svg__e",
  transform: "translate(56 41)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "development_svg__g",
  width: 17,
  height: 30,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  className: "development_svg__h",
  x: 1,
  y: 1,
  width: 15,
  height: 28,
  rx: 3
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "development_svg__f",
  d: "M57.919 63.758h13.515"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "development_svg__d",
  d: "M28.157 38.115l11.307-11.307M36.402 38.115l11.307-11.307"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  className: "development_svg__e",
  transform: "translate(3 34)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "development_svg__g",
  width: 28,
  height: 37,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  className: "development_svg__h",
  x: 1,
  y: 1,
  width: 26,
  height: 35,
  rx: 3
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "development_svg__f",
  d: "M4.466 63.758h24.968M11.418 53.478l6.032-6.032M17.418 53.478l6.032-6.032"
});

var SvgDevelopment = function SvgDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

export default "data:image/svg+xml;base64,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";
export { SvgDevelopment as ReactComponent };